import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const head = document.getElementsByTagName('head')[0];

if (
  environment.OnetrustCookieConsentKey == null ||
  environment.OnetrustCookieConsentKey == ''
) {
  environment.OnetrustCookieConsentKey = '29145a4b-89f5-45ce-ab99-7980e3df4ff5';
}

const consentKey = environment.OnetrustCookieConsentKey;

const scriptAutoblock = document.createElement('script');
scriptAutoblock.type = 'text/javascript';
scriptAutoblock.src = `https://cdn.cookielaw.org/consent/${consentKey}/OtAutoBlock.js`;
head.appendChild(scriptAutoblock);

const scriptOneTrustCookie = document.createElement('script');
scriptOneTrustCookie.type = 'text/javascript';
scriptOneTrustCookie.src =
  'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
scriptOneTrustCookie.setAttribute('data-domain-script', consentKey);
scriptOneTrustCookie.setAttribute('data-language', 'en');
scriptOneTrustCookie.setAttribute('charset', 'UTF-8');
head.appendChild(scriptOneTrustCookie);

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.error(err));
